import { render, staticRenderFns } from "./DirectReferral.vue?vue&type=template&id=65a4cc7c"
import script from "./DirectReferral.vue?vue&type=script&lang=js"
export * from "./DirectReferral.vue?vue&type=script&lang=js"
import style0 from "./DirectReferral.vue?vue&type=style&index=0&id=65a4cc7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports